import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './PaymentTestButton.css';

const PaymentTestButton: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const testBookings = [
    { id: '1', name: 'Test-Buchung 1', amount: 2850, participants: 45 },
    { id: '2', name: 'Test-Buchung 2', amount: 1900, participants: 30 },
    { id: '3', name: 'Test-Buchung 3', amount: 3500, participants: 60 }
  ];

  const handleTestPayment = (bookingId: string) => {
    if (!isAuthenticated) {
      alert('Bitte zuerst einloggen!');
      navigate('/login');
      return;
    }
    navigate(`/checkout/${bookingId}`);
  };

  return (
    <div className="payment-test-container">
      <h3>🧪 Payment Test-Buttons</h3>
      <p>Klicken Sie auf eine Buchung, um den Payment-Flow zu testen:</p>
      
      <div className="test-bookings">
        {testBookings.map(booking => (
          <button
            key={booking.id}
            className="test-booking-button"
            onClick={() => handleTestPayment(booking.id)}
          >
            <div className="booking-info">
              <strong>{booking.name}</strong>
              <span>{booking.participants} Personen</span>
            </div>
            <div className="booking-amount">
              €{(booking.amount / 100).toFixed(2)}
            </div>
            <div className="test-action">
              → Zur Zahlung
            </div>
          </button>
        ))}
      </div>

      <div className="test-cards-info">
        <h4>Test-Kreditkarten:</h4>
        <ul>
          <li>✅ Erfolg: 4242 4242 4242 4242</li>
          <li>❌ Ablehnung: 4000 0000 0000 0002</li>
          <li>🔐 3D Secure: 4000 0027 6000 3184</li>
        </ul>
        <p>CVV: beliebige 3 Ziffern | Ablauf: beliebiges zukünftiges Datum</p>
      </div>
    </div>
  );
};

export default PaymentTestButton;
